<template>
    <div v-if="newsData" :style="newsData.layout">

        <div v-if="newsData.ggbox" v-for="it,i in newsData.ggbox" :key="i" :style="it.layout">
            <div style="width: 100%;height: 200px; position: relative;">
                <div :style="{ backgroundImage: 'url(' + it.imgurl + ')' }"
                     style="background-size: cover;background-position: center center; background-size: cover; width: 100%;height: 100%;position: absolute;top:0;left: 0;">
                </div>
            </div>
            <div :style="it.contlayout" style="position: relative;">
                <div v-if="it.showtm!=''" style="padding:5px 10px; border:1px solid #fff;position: absolute;top:10px;left: 0;">
                    {{it.showtm}}
                </div>
                <div style="width: 100%;margin-top: 20px;font-size: 1.3rem;">
                    {{it.titna}}
                </div>
                <div style="width: 100%;height: 160px;margin-top: 20px;overflow: hidden;" v-html="it.titsm">
                    {{it.titsm}}
                </div>

                <div style="width: 100%;height: 100%;position: absolute;top:0;left: 0;cursor: pointer;" @click="goto(it)"></div>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        name: "newsboxlist",
        props:{
            newsData:{}
        },
        methods:{
            goto(it){
                if(it.type==undefined){return false}

                if(it.type=='link'){
                    window.open(it.url, it.target);
                }
                if(it.type=='rout'){
                    //this.$router.push({'path': it.url, query: {'id': it.valval}});
                    var url='';
                    if(it.valval!='') {
                        url = this.$router.resolve({path: it.url, query: {'id': it.valval}}).href;
                    }
                    if(it.valval==''){
                        url = this.$router.resolve({path: it.url}).href;
                    }
                    if(url!='') {
                        window.open(url, it.target);
                    }

                }
            }
        },

    }
</script>

<style scoped>
    a{
        text-decoration: none;
        color: #3a3a3a;
    }

</style>



// WEBPACK FOOTER //
// src/components/comp/newsboxlist.vue